import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();

      // pagination
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());

      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }
      // search
      if (search) params.append("search", search.trim());

      // sorting
      console.log("filters", filters);

      const filterPayload = FilterBuilder(filters ?? []);

      console.log("BODY Filters", filterPayload);

      const body = {
        filters: filterPayload,
      };
      const response = await Axios.post(
        `${API_ENDPOINT?.MASTERS?.PRODUCT?.LIST}?${params.toString()}`,
        body,
      );

      return {
        data: response.data.data || response.data || [],
        rowCount: response.data.count || response.data.length || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchProductsAndServices error:",
        error.response?.data || error.message,
      );
      throw new Error("Failed to fetch products and services");
    }
  },
);

// Fetch Product By ID
export const fetchProductById = createAsyncThunk(
  "product/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        `${API_ENDPOINT?.MASTERS?.PRODUCT?.DETAIL(id)}`,
      );
      return response.data || response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch products and services by ID",
      );
    }
  },
);

// Active Products dropdown
export const fetchProductsByDropDown = createAsyncThunk(
  "products/fetchByDropDown",

  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT?.MASTERS?.PRODUCT?.DROPDOWN}`,
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch products and services list",
      );
    }
  },
);
export const fetchProductsDropDownByModel = createAsyncThunk(
  "products/fetchProductsDropDownByModel",

  async (model_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT?.MASTERS?.PRODUCT?.DROPDOWN_BY_MODEL(model_id)}`,
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch products and services list",
      );
    }
  },
);

export const updateProduct = createAsyncThunk(
  "product/updateProduct",
  async ({ id, data }: { id: string; data: any }, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `${API_ENDPOINT?.MASTERS?.PRODUCT?.UPDATE(id)}`,
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update products and services",
      );
    }
  },
);

export const updateStatusInProduct = createAsyncThunk(
  "product/updateStatusInProduct",
  async ({ id, data }: { id: string; data: any }, { rejectWithValue }) => {
    try {
      const payload = { is_active: data.is_active };
      const response: any = await Axios.patch(
        `${API_ENDPOINT?.MASTERS?.PRODUCT?.STATUS_UPDATE(id)}`,
        payload,
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data ||
          "Failed to update status in products and services",
      );
    }
  },
);

export const addProduct = createAsyncThunk(
  "product/addProduct",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `${API_ENDPOINT?.MASTERS?.PRODUCT?.CREATE}`,
        data,
      );
      return response;
    } catch (err: any) {
      console.error("addProductsAndServices: Error occurred:", err);
      console.error("addProductsAndServices: Error response:", err.response);
      return rejectWithValue(
        err.response?.data || "Failed to add products and services",
      );
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "product/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      await Axios.delete(`${API_ENDPOINT?.MASTERS?.PRODUCT?.DELETE(id)}`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);

export const exportProductCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);

  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${API_ENDPOINT?.MASTERS?.PRODUCT?.EXPORT}?${params.toString()}`,
    body,
    {
      responseType: "blob",
    },
  );

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "productsandservices"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};

export const exportProductTallyCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);

  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${API_ENDPOINT?.MASTERS?.PRODUCT?.EXPORT_TALLY}?${params.toString()}`,
    body,
    {
      responseType: "blob",
    },
  );

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "products_tally"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
